import React, {useEffect, useState} from 'react';
import './ProgrammerSupervision.scss';
import _axios from "../../../../httpService";
import {prefixUrl} from "../../../../utils/utilsData";
import {toast} from "react-toastify";
import Loader from "../../../Loader";
import CircularChart from "./SupervisionItems/CircularChart";
import DynaSelectBox from "../../DynaView/DynaSelectBox";

const ProgrammerSupervision = () => {

  const [initialData, setInitialData] = useState({});
  const [isLoad, setIsLoad] = useState(false);
  const [sendData, setSendData] = useState({
    projectId: "",
    year: "",
    monthNumber: ""
  })
  const [componentData, setComponentData] = useState()

  useEffect(() => {
    _axios.get(prefixUrl() + "/arkaMonitoring/?request=programmerMonitoringData").then((response) => {
      if (response.data.status) {
        setInitialData(response.data.data);
        setComponentData(response.data.data?.taskGanttChart);
        setSendData(response?.data?.data?.taskGanttChartDefaultValue)
        setIsLoad(true)
      } else {
        toast.error(response.data.message);
      }
    })
  }, []);

  const years = [
    {label: "1403", value: "1403"},
    {label: "1404", value: "1404"},
    {label: "1405", value: "1405"},
    {label: "1406", value: "1406"},
    {label: "1407", value: "1407"},
    {label: "1408", value: "1408"},
    {label: "1409", value: "1409"},
    {label: "1410", value: "1410"},
  ]
  const months = [
    {label: "فروردین", value: "1"},
    {label: "اردیبهشت", value: "2"},
    {label: "خرداد", value: "3"},
    {label: "تیر", value: "4"},
    {label: "مرداد", value: "5"},
    {label: "شهریور", value: "6"},
    {label: "مهر", value: "7"},
    {label: "آبان", value: "8"},
    {label: "آذر", value: "9"},
    {label: "دی", value: "10"},
    {label: "بهمن", value: "11"},
    {label: "اسفند", value: "12"},
  ]

  const filterHandler = async () => {
    const response = await _axios.get(prefixUrl() + `/arkaMonitoring/?request=taskGanttChart&projectId=${sendData?.projectId}&year=${sendData?.year}&monthNumber=${sendData?.monthNumber}`)
    if (response?.data?.status) {
      setComponentData(response?.data?.data)
    } else {
      toast.error(response?.data?.message)
    }
  }

  try {
    return (
      <>
        {isLoad ?
          <section className={"ProgrammerSupervision"}>
            <div className={"row-show-CircularChart"}>
              <h5>درصد موفقیت براساس سال و ماه</h5>
              <CircularChart
                firstValue={70}
                secondValue={10}
                generalTitle={"تعداد کل تسک ها"}
                firstTitle={"تعداد تسک موفق"}
                secondTitle={"تعداد تسک ناموفق"}
                firstColor={"#1B9C85"}
                secondColor={"#EF4659"}
                data={initialData?.programmerTotalTaskReport}
              />
              <CircularChart
                firstValue={70}
                secondValue={10}
                generalTitle={"تعداد کل تسک های باز ماه"}
                firstTitle={"تعداد تسک موفق"}
                secondTitle={"تعداد تسک ناموفق"}
                firstColor={"#FFA800"}
                secondColor={"#F6683B"}
                data={initialData?.programmerCurrentTaskReport}
              />
              <CircularChart
                firstValue={70}
                secondValue={10}
                generalTitle={"تعداد کل تسک ها"}
                firstTitle={"تعداد تسک موفق"}
                secondTitle={"تعداد تسک ناموفق"}
                firstColor={"#4BC7AE"}
                secondColor={"#FF8800"}
                data={initialData?.programmerTotalTaskReportForYear}
              />
            </div>

            <div className={"row-show-CircularChart"}>
              <h5>گانت چارت مدیریت زمان تسک</h5>
              <div className={"row-select-box"}>
                <DynaSelectBox options={initialData?.projectsList}
                               hasFilter={false}
                               label={"نام پروژه"}
                               className={"solid-dyna-input"}
                               value={sendData?.projectId.toString()}
                               onChange={(data) => setSendData({...sendData, projectId: data.value})}
                />
                <DynaSelectBox options={years}
                               hasFilter={false}
                               label={"سال"}
                               className={"solid-dyna-input"}
                               value={sendData?.year.toString()}
                               onChange={(data) => setSendData({...sendData, year: data.value})}
                />
                <DynaSelectBox options={months}
                               hasFilter={false}
                               label={"ماه"}
                               className={"solid-dyna-input"}
                               value={sendData?.monthNumber.toString()}
                               onChange={(data) => setSendData({...sendData, monthNumber: data.value})}
                />
                <button className={"filter-but"} onClick={filterHandler}>فیلتر</button>
              </div>

              {componentData?.length > 0 ?
                <ul className={"GanttChartList"}>
                  {componentData?.map((item, index) => (
                    <li key={index} className="task-row">
                      <div className='cell-box'>
                        {[...Array(32).keys()].reverse().map((day) => (
                          <div key={day} className='day-cell'
                               style={{backgroundColor: day + 1 >= item.startDate && day + 1 <= item.endDate ? item.color : ''}}
                          />
                        ))}
                      </div>
                      <h6 className="task-name iransans">{item.name}</h6>
                    </li>
                  ))}
                </ul> : <h6 className={"no-data"}>اطلاعات یافت نشد</h6>
              }
            </div>

            <div className={"row-show-CircularChart"}>
              <h5>لیست امتیازات</h5>
              <ul className={"table-list"}>
                <li className={"li-header"}>
                  <h6 style={{width: "10%"}}>ماه</h6>
                  <h6 style={{width: "10%"}}>سال</h6>
                  <h6 style={{width: "10%"}}>تعداد تسک ها</h6>
                  <h6 style={{width: "10%"}}>تسک موفق</h6>
                  <h6 style={{width: "10%"}}>تسک ناموفق</h6>
                  <h6 style={{width: "10%"}}>امتیاز مثبت</h6>
                  <h6 style={{width: "10%"}}>امتیاز منفی</h6>
                  <h6 style={{width: "10%"}}>امتیاز عدم ثبت گزارشکار</h6>
                  <h6 style={{width: "10%"}}>امتیاز منفی تایید تسک</h6>
                  <h6 style={{width: "10%"}}>امتیاز کل</h6>
                </li>

                {initialData?.programmerScoresTable?.length > 0 ? initialData?.programmerScoresTable?.map((item, index) =>
                  <li key={"row" + index}>
                    <h6 style={{width: "10%"}}>{item?.month}</h6>
                    <h6 style={{width: "10%"}}>{item?.year}</h6>
                    <h6 style={{width: "10%"}}>{item?.totalTask}</h6>
                    <h6 style={{width: "10%"}}>{item?.successTask}</h6>
                    <h6 style={{width: "10%"}}>{item?.failureTask}</h6>
                    <h6 style={{width: "10%"}}>{item?.positiveScore}</h6>
                    <h6 style={{width: "10%"}}>{item?.negativeScore}</h6>
                    <h6 style={{width: "10%"}}>{item?.taskApproveScore}</h6>
                    <h6 style={{width: "10%"}}>{item?.taskReportScore}</h6>
                    <h6 style={{width: "10%"}}>{item?.totalScore}</h6>
                  </li>
                ) : <li className={"no-task"}>تسکی نیست</li>
                }
              </ul>
            </div>

          </section> : <Loader/>}
      </>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default ProgrammerSupervision;